import { off, onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { realtimeDB } from "./Backend";
import LiveVideoPlayer from "./LiveVideoPlayer";

const VideoCarousel = () => {
        const [videos,setVideos]=useState([]);
        
        useEffect(()=>{
            const dbRef = ref(realtimeDB,"prevLiveVideos");
            const prevLiveListener = onValue(dbRef, (snapshot)=>{
                const items = [];
                if (snapshot.exists()) {
                  snapshot.forEach((childSnapshot)=>{
                    items.push(childSnapshot.val());
                  });
                  setVideos(items.reverse());
                }
            });

            return()=> off(dbRef,prevLiveListener);
        },[]);



    return ( 
        <div className="videocarousel" style={{width:"100%",height:"100vh",display:"grid",placeItems:"center",overflow:"auto",gap:"20px"}}>
                
                {videos && videos.map(data =>(
                <div style={{width:"90%",height:"auto",borderRadius:"10px",backgroundColor:"black"}}>
                        <LiveVideoPlayer vidheight={"70vh"} vidwidth={"100%"} 
                        key={data.title}
                        extUrl={data.url}
                        extTitle={data.title}
                    />
                </div>        
                ))}
         
        </div>
     );
}
export default VideoCarousel;